import tippy from 'tippy.js';

class Tooltip {
    init() {
        tippy('.tooltip', {
            dynamicTitle: true,
            position: 'right',
            arrow: true,
            popperOptions: {
                modifiers: {
                    flip: {
                        behavior: ['right', 'top']
                    }
                }
            }
        });

        tippy('.tooltip-like', {
            position: 'top',
            arrow: true,
            dynamicTitle: true,
        });
    }
}

export default Tooltip;